const ready = (callback) => {
  if (document.readyState !== 'loading') callback()
  else document.addEventListener('DOMContentLoaded', callback)
}

ready(() => {
  let $playButtons = document.querySelectorAll('.js-show-layer')

  $playButtons.forEach(btn => {
    btn.addEventListener('click', function () {
      let $wrapper = this.parentNode.closest('.js-video-wrapper')
      videoAddLayer($wrapper)
    }, false)
  })

  // show privacy layer (and hide the poster frame)
  function videoAddLayer ($wrapper) {
    // hide poster
    $wrapper.classList.add('video--layered')
    let $button = $wrapper.querySelector('.js-play-video')

    $button.addEventListener('click', function () {
      videoPlay($wrapper)
    }, false)
  }

  // play the targeted video (and hide the privacy layer)
  function videoPlay ($wrapper) {
    // hide layer
    $wrapper.classList.add('video--active')

    let $iframe = $wrapper.querySelector('.js-video-iframe')

    let src = $iframe.getAttribute('data-src')
    // add iframe src in, starting the video
    $iframe.setAttribute('src', src)
  }
})
